let audioFiles = {
  round1: {
    vo_intro: {
      file: "vo/round_01_vox_01_intro.mp3",
      delay: 2000,
      track: "vo",
      alt: "Ugh, what in the name of Blitzen's antlers happened? And why am I half-nudie? Better hurry and get my cabana wear back on, or I'm gonna freeze my sleigh bells off!"
    },
    vo_shorts: {
      file: "vo/round_01_vox_02_shorts.mp3",
      track: "vo",
      alt: "Okay, first on the nice list: let's slide my shorts back on and cover these jolly gams!"
    },
    vo_shirt: {
      file: "vo/round_01_vox_03_shirt.mp3",
      track: "vo",
      delay: 300,
      alt: "There we go. Now, where's the top to match these bottoms?"
    },
    vo_sandals: {
      file: "vo/round_01_vox_04_sandals.mp3",
      track: "vo",
      delay: 300,
      alt: "That's the Christmas spirit! Okay, where are my slippies for poolside joy?"
    },
    vo_hat: {
      file: "vo/round_01_vox_05_hat.mp3",
      track: "vo",
      delay: 300,
      alt: "Ah, like warm chocolate chip cookies on my tootsies! So, where did that delightful head-topper land?"
    },
    vo_sunglasses: {
      file: "vo/round_01_vox_06_sunglasses.mp3",
      track: "vo",
      delay: 300,
      alt: "Now that's sealin' in the heat! Finally, to complete this ensemble, I just need my cool guy shades!"
    },
    vo_jetpack: {
      file: "vo/round_01_vox_07_jetpack.mp3",
      track: "vo",
      delay: 300,
      alt: "Ho ho ho, it's a Christmas miracle! Now, to get back on track, I just need my jetpack...",
      startNext: 300
    },
    vo_outro: {
      file: "vo/round_01_vox_08_outro.mp3",
      track: "vo",
      delay: 300,
      alt: "Ohh, what good tidings!",
      startNext: 50
    },
    sfx_incorrect: {
      file: "sfx/round_01_sfx_cloth_incorrect.mp3",
      track: "sfx",
      alt: ""
    },
    sfx_correct: {
      file: "sfx/round_01_sfx_cloth_correct.mp3",
      track: "sfx",
      alt: ""
    },
    ambience: {
      file: "music/round_01_ambience_loop.mp3",
      track: "ambience",
      loop: true
    },
    music: {
      file: "music/round_01_music_loop.mp3",
      track: "music",
      loop: true
    }
  },
  round2: {
    vo_intro: {
      file: "vo/round_02_vox_intro.mp3",
      track: "vo",
      alt: "Now I just need to gently enter the joyful jetpack sequence, and I'm on my way..."
    },
    vo_correct1: {
      file: "vo/round_02_vox_correct_01.mp3",
      track: "vo",
      delay: 150,
      alt: "Ho ho ho..."
    },
    vo_correct2: {
      file: "vo/round_02_vox_correct_02.mp3",
      track: "vo",
      delay: 150,
      alt: "Ho ho ho..."
    },
    vo_correct3: {
      file: "vo/round_02_vox_correct_03.mp3",
      track: "vo",
      delay: 150,
      alt: "Ho ho ho ho..."
    },
    vo_correct4: {
      file: "vo/round_02_vox_correct_04.mp3",
      track: "vo",
      delay: 150,
      alt: "Ho-HO!"
    },
    vo_correct5: {
      file: "vo/round_02_vox_correct_05.mp3",
      delay: 150,
      track: "vo",
      alt: ""
    },
    vo_correct6: {
      file: "vo/round_02_vox_correct_06.mp3",
      delay: 150,
      track: "vo",
      alt: "Oh, sweet Christmas carols, here we go!"
    },
    vo_incorrect: {
      // if multiple files, assume randomize
      files: [
        {'file': 'vo/round_02_vox_incorrect_01.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_02.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_03.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_04.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_05.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_06.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_07.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_08.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_09.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_10.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_11.mp3', 'track': 'vo'},
        {'file': 'vo/round_02_vox_incorrect_12.mp3', 'track': 'vo'}
      ],
      delay: 150,
      track: "vo",
      alt: ""
    },
    sfx_button1: {
      file: "sfx/round_02_sfx_jetpackbutton_01.mp3",
      track: "sfx",
      alt: ""
    },
    sfx_button2: {
      file: "sfx/round_02_sfx_jetpackbutton_02.mp3",
      track: "sfx",
      alt: ""
    },
    sfx_button3: {
      file: "sfx/round_02_sfx_jetpackbutton_03.mp3",
      track: "sfx",
      alt: ""
    },
    sfx_button4: {
      file: "sfx/round_02_sfx_jetpackbutton_04.mp3",
      track: "sfx",
      alt: ""
    },
    sfx_launchButton: {
      file: "sfx/round_02_sfx_jetpackbutton_launchbutton.mp3",
      track: "sfx",
      alt: ""
    }
  }
}

export {audioFiles}
